import React from 'react';
import { Button, Space } from 'antd';
import SelectWithFetchNext from '../../../shared/components/select-with-fetch-next';
import * as sharedActions from '../../../shared/store/actions';
import SignatureModal from './signature-modal';

import '../styles.less';

const SignatureLookup = ({
  rootContainer,
  onSignatureChange,
  showSignatureOnPdf,
  formParameters,
  onSaveSignatureClick,
  onCancelSignatureClick,
  permissions,
  onCreateSignatureClick,
  showSignatureModal,
  onCloseCreateSignatureModal,
  insuredId,
}) => {
  return (
    <Space>
      <SelectWithFetchNext
        rootContainer={rootContainer}
        fetchNext={sharedActions.getSignaturesLookup}
        placeholder="Signature"
        onSelect={onSignatureChange}
        className={'signature-lookup-append'}
      />

      {showSignatureOnPdf && formParameters && formParameters.showSignature ? (
        <Space>
          <Button type="primary" onClick={onSaveSignatureClick}>
            Save Signature
          </Button>
          <Button type="primary" danger onClick={onCancelSignatureClick}>
            Cancel Adding Signature
          </Button>
        </Space>
      ) : undefined}

      {!showSignatureOnPdf && formParameters && formParameters.showSignature ? (
        <Button disabled={!permissions || !permissions.permissions_AcordForms_Signatures.canAdd} onClick={onCreateSignatureClick}>
          Create new Signature
        </Button>
      ) : undefined}

      {showSignatureModal ? (
        <SignatureModal closeModal={onCloseCreateSignatureModal} rootContainer={rootContainer} truckingCompanyId={insuredId} />
      ) : null}
    </Space>
  );
};

export default SignatureLookup;
